module.exports = __webpack_public_path__ + "img/Icon_CreBoardBtn.be1e4f3d.png";